import styled from 'styled-components';

export const MainConfig = styled.div`
    display: flex;
    flex-direction: column !important;
`;